import { render } from "./channelWeChat.vue?vue&type=template&id=4ff2e5b2&scoped=true&ts=true"
import script from "./channelWeChat.vue?vue&type=script&lang=ts"
export * from "./channelWeChat.vue?vue&type=script&lang=ts"

import "./channelWeChat.vue?vue&type=style&index=0&id=4ff2e5b2&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff2e5b2"]])

export default __exports__